import { render, staticRenderFns } from "./UpdateCompact.vue?vue&type=template&id=76dde62c&"
import script from "./UpdateCompact.vue?vue&type=script&lang=js&"
export * from "./UpdateCompact.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCompact.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports